"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deal_info_types_1 = require("@wix/wix-vod-constants/dist/common/deal-info-types");
var globalTypes_1 = require("../../generated/globalTypes");
var pricing_1 = require("../../mappers/pricing");
exports.mapPricingToVod = pricing_1.createMapPricingToVod(new Map([
    [globalTypes_1.SettingsDefaultPricingType.SALE, deal_info_types_1.DEAL_INFO_TYPES.SALE],
    [globalTypes_1.SettingsDefaultPricingType.RENT, deal_info_types_1.DEAL_INFO_TYPES.RENT],
]));
exports.mapPricingToGql = pricing_1.createMapPricingToGql(new Map([
    [deal_info_types_1.DEAL_INFO_TYPES.SALE, globalTypes_1.SettingsDefaultPricingType.SALE],
    [deal_info_types_1.DEAL_INFO_TYPES.RENT, globalTypes_1.SettingsDefaultPricingType.RENT],
]));
//# sourceMappingURL=pricing.js.map